export default __webpack_public_path__ + "static/media/Band CT Correct.2661b469.mp4";